<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import GenericLink from '../link-generic/GenericLink'
import { PuCampsiteAvailabilityLinkProps } from './PuCampsiteAvailabilityLinkProps'
import { getPriceParamsFromQuery } from '~/utility/getPriceParamsFromQuery'

@Component({
  mixins: [GenericLink],
})
class PuCampsiteAvailabilityLink
  extends Vue
  implements PuCampsiteAvailabilityLinkProps
{
  @Prop({
    required: true,
    type: String,
    validator: (s: string) => s.length > 0,
  })
  slug: string

  @Prop({ required: false, type: String })
  pitchtypeId: string

  @Prop()
  extendedQuery?: Record<string, string | (string | null)[]>

  @Prop({ default: 'campsite' })
  excludeType?: string

  get linkData() {
    return {
      query: {
        ...this.linkQuery,
        pitchtype: this.pitchtypeId || undefined,
      },
      path: `/campsite/${this.slug}/check-availability/`,
    }
  }

  private get linkQuery() {
    return this.extendedQuery
      ? { ...this.pricingParams, ...this.extendedQuery }
      : this.pricingParams
  }

  private get pricingParams() {
    return getPriceParamsFromQuery(this.$route.query)
  }
}

export default toNative(PuCampsiteAvailabilityLink)
</script>
